/* eslint-disable react/prefer-stateless-function */
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { FormText, ListGroupItem, ListGroupItemText } from 'reactstrap'
import { API_URL } from "../../../../../../../constants";

function Comments({id, commentText, createdAt, createdBy, token}) {
  const [ author, setAuthor ] = useState('')
  useEffect(() => {
    if(createdBy && token) {
      const fetchData = async() => {
        return axios
          .get(
            `${ API_URL }user/${ createdBy.substring(
              createdBy.lastIndexOf('/') + 1
            ) }`,
            {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: token,
              },
            }
          )
          .then(({data}) => {
            if(
              data &&
              data['@graph'] &&
              data['@graph'].length &&
              data['@graph'].length > 0
            ) {
              data['@graph'].forEach(authorData => {
                if(authorData) {
                  const {firstName, lastName} = authorData
                  setAuthor(`${ firstName } ${ lastName }`)
                }
              })
            }
          })
          .catch(error => console.log(error))
      }
      fetchData()
    }
  }, [ token, createdBy ])
  return (
    <>
      <ListGroupItem className="mt-2" key={ id } color="warning">
        <ListGroupItemText style={ {whiteSpace: 'pre-line'} }>
          { commentText }
        </ListGroupItemText>
        { author && <FormText color="muted">{ author }</FormText> }
        { createdAt && (
          <FormText color="muted">
            { new Date(createdAt).toLocaleDateString() }
          </FormText>
        ) }
      </ListGroupItem>
    </>
  )
}

export default Comments
